module.exports = __webpack_public_path__ + "img/Body_feathers_MetalRoughness.0eec7c9.jpg";